const ewTransformationsSlider = new Swiper(".ew-transformations__slider", {
  slidesPerView: "auto",
  spaceBetween: 32,
  grabCursor: true,
  freeMode: true,
  speed: 600,

  breakpoints: {
    0: {
      spaceBetween: 20,
      slidesPerView: 1.3,
    },
    768: {
      spaceBetween: 28,
    },
    1200: {
      spaceBetween: 32,
    },
  },
});

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  initHeroAnimations();
  initRevealAnimations();
  initRefresh();
});

/* =========================================
   HERO
========================================= */

function initHeroAnimations() {
  const hero = document.querySelector(".ewh");
  const bgImg = document.querySelector(".ewh__bg");
  const header = document.querySelector(".ewh__title");
  const heroText = document.querySelector(".ewh__subtitle");

  if (!hero || !bgImg) return;

  gsap.fromTo(
    bgImg,
    { scale: 1 },
    {
      scale: 1.25,
      ease: "none",
      scrollTrigger: {
        trigger: hero,
        start: "top top+=1",
        end: "bottom top",
        scrub: 0.6,
        invalidateOnRefresh: true,
      },
    }
  );

  const introTl = gsap.timeline({
    scrollTrigger: {
      trigger: hero,
      start: "top 80%",
      once: true,
    },
    defaults: {
      ease: "power3.out",
    },
  });

  if (header) {
    introTl.fromTo(
      header,
      { y: -24 },
      { y: 0, duration: 0.7 },
      0.5
    );
  }

  if (heroText) {
    introTl.fromTo(
      heroText,
      { x: -28, opacity: 0 },
      { x: 0, opacity: 1, duration: 0.9 },
      0.65
    );
  }
}

/* =========================================
   COMMON REVEALS
========================================= */

function initRevealAnimations() {

  gsap.utils.toArray(".gs-reveal").forEach((el) => {
    gsap.fromTo(
      el,
      { y: 18, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 65%",
          once: true,
        },
      }
    );
  });

  gsap.utils.toArray(".gs-image-scale").forEach((el) => {
    gsap.fromTo(
      el,
      { scale: 1 },
      {
        scale: 1.1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 75%",
          once: true,
        },
      }
    );
  });

  gsap.utils.toArray(".gs-reveal-stagger").forEach((wrap) => {
    gsap.fromTo(
      wrap.children,
      { y: 16, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.9,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: wrap,
          start: "top 70%",
          once: true,
        },
      }
    );
  });

  gsap.utils.toArray(".gs-reveal-stagger-late").forEach((wrap) => {
    gsap.fromTo(
      wrap.children,
      { y: 16, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.1,
        ease: "power3.out",
        stagger: 0.3,
        scrollTrigger: {
          trigger: wrap,
          start: "top 50%",
          once: true,
        },
      }
    );
  });

}

/* =========================================
   REFRESH
========================================= */

function initRefresh() {

  const refresh = () => ScrollTrigger.refresh();

  window.addEventListener("load", refresh);

  document.querySelectorAll("img[loading='lazy']").forEach((img) => {
    if (!img.complete) {
      img.addEventListener("load", refresh, { once: true });
    }
  });

  requestAnimationFrame(refresh);
}